module.exports = __webpack_public_path__ + "img/news-header.78f843b9.jpg";